module.exports = __webpack_public_path__ + "static/media/tel.0bc0442b.svg";